<template>
	<div>
		<b-tabs v-model="activeTab">
			<b-tab title="Все отмеченные"></b-tab>
			<b-tab title="Мероприятия"></b-tab>
			<b-tab title="Услуги"></b-tab>
			<b-tab title="Продукты"></b-tab>
			<b-tab title="Онлайн"></b-tab>
			<b-tab title="Офлайн"></b-tab>
			<b-tab title="Свалка"></b-tab>
			<b-tab title="Отчётность">
				<div class="row">
					<div class="col-md-6">
						<b-form ref="form" :model="form">
							<b-form-group label="">
								<b-form-select v-model="role" class="w-auto">
									<option v-for="(role, key) in roles" :key="key" :label="role.name" :value="role.value"></option>
								</b-form-select>
							</b-form-group>
						</b-form>
					</div>
					<div class="col-md-6">
						<div class="float-right">
							<b-button
								v-if="$store.state.user.role === 'superadmin' || $store.state.user.role === 'admin' || $store.state.user.role === 'supermarketer'"
								:class="prepareMarketers ? 'loading' : ''"
								variant="primary"
								@click="onSendMarketingReport"
							><i class="fa fa-mail-forward"></i> Отчётность по маркетологам</b-button>
						</div>
					</div>
				</div>
				<div class="table-wrap">
					<payment-report-table
					v-if="preloading"
						:type="role"
						:users="users"
						:dateStart="getDateStart()">
					</payment-report-table>
				</div>
			</b-tab>
		</b-tabs>
	</div>
</template>
<script>
import user from '@/models/user/user'
import PaymentReportTable from '@/components/payment/payment-report-table'
export default {
	components: {
		'payment-report-table': PaymentReportTable
	},
	data () {
		return {
			preloading: false,
			activeTab: 7,
			type: '',
			tabs: {
				0: 'all',
				1: 'event',
				2: 'service',
				3: 'product',
				4: 'online',
				5: 'offline',
				6: 'trash',
				7: 'statistic'
			},
			role: 0,
			roles: [
				{value: 0, name: 'Менеджеры'}
			],
			users: {},
			marketers: [],
			prepareMarketers: false,
			form: {}
		}
	},
	created () {
		this.getUsers()
	},
	mounted () {
		this.type = this.$route.params.type
	},
	methods: {
		getUsers () {
			user.getAll().then((result) => {
				let users = {}
				let length = result.body.length
				if (length === 0) return false
				result.body.forEach((value, key) => {
					users[value.id] = value
					if (key === length - 1) {
						this.users = users
						this.handlePrepareMarketer()
						this.preloading = true
					}
					if (value.role === 'marketer' && value.status === 1) {
						this.roles.push({value: value.id, name: value.first_name + ' ' + value.last_name})
					}
				})
			})
		},
		handleSelectChange (el) {
			// console.log(this.role)
		},
		getDateStart () {
			return typeof this.$route.query.date_start !== 'undefined' ? this.$route.query.date_start : ''
		},
		handlePrepareMarketer () {
			for (let key in this.users) {
				if (this.users[key].role === 'marketer' || this.users[key].role === 'supermarketer') {
					this.marketers.push(this.users[key])
				}
			}
		},
		onSendMarketingReport () {
			this.prepareMarketers = true
			this.$http.post(this.$store.state.apiURL + '/v1/payment/report/notify', { period_date_start: this.getDateStart() })
				.then((response) => {
					this.prepareMarketers = false
					this.$notify({
						group: 'default',
						type: 'success',
						title: 'Отчёт оптравлеён.',
						text: 'Отчёт оптравлеён на ваш адрес электронной почты.'
					})
				})
		},
		getContribSum (items) {
			let result = 0
			items.forEach((value, key) => {
				if (value.hasOwnProperty('percent') && value.percent > 0) {
					result = result + Number(value.amount) / value.index
				} else {
					result = result + Number(value.amount)
				}
			})

			return result
		}
	},
	watch: {
		activeTab: function (value) {
			this.$router.push({path: '/payments/list/' + this.tabs[value], query: {'date_start': this.$route.query.date_start}})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/payment/list/statistic.vue